import { convertStyleObjectToCss as e } from "../../utils/style-helpers.mjs";
import { useLinkExtensionToolbar as t } from "./use-link-extension-toolbar.mjs";
import { mergeAttributes as n } from "@tiptap/react";
import { Link as r } from "@tiptap/extension-link";
//#region src/extensions/link-extension/index.ts
var i = (t) => r.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			color: { default: t?.color ?? "rgb(17 85 204)" }
		};
	},
	renderHTML({ HTMLAttributes: t, mark: r }) {
		let i = {
			color: r.attrs.color,
			textDecorationLine: "underline"
		};
		return [
			"a",
			n(t, { style: e(i) }),
			0
		];
	}
}), a = (e) => i(e).configure({ openOnClick: !1 }), o = (e) => i(e).configure({ HTMLAttributes: { rel: "noopener noreferrer" } });
//#endregion
export { a as createLinkExtension, o as createSimpleLinkExtension, t as useLinkExtensionToolbar };
